export const EMAIL_PATTERN: RegExp = /^[a-zA-Z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&\'*+/=?^_`{|}~-]+)*@(?:[a-zA-ZäöüÄÖÜ0-9](?:[a-zA-ZäöüÄÖÜ0-9-]*[a-zA-ZäöüÄÖÜ0-9])?\.)+[a-zA-ZäöüÄÖÜ0-9](?:[a-zA-Z0-9-]*[a-zA-ZäöüÄÖÜ0-9])?$/;
export const PASSWORD_PATTERN: RegExp = /^(?=.*[üäößa-z])(?=.*[ÜÄÖA-Z])(?=.*\d).{12,128}$/;
export const NUMBER_PATTERN: RegExp = /\d/;
export const CHAR_PATTERN: RegExp = /[a-z]/i;
